import { CircularProgress, FormControl, MenuItem, Select } from "@mui/material";
import React, { useState } from "react";
import StatusChangeModal from "./status-change-modal";
import { Helper } from "../../../../tools/Helper";
import { api_Routes } from "../../../../tools/api_Routes";
import {
  successToaster,
  errorToaster,
} from "../../../../helper/toasterConfiguration";
import { setOpen } from "../../../../Redux/ModalReducer";
import { useDispatch } from "react-redux";

const StatusChanger = ({
  data,
  setData,
  rowsPerPage,
  currentPage,
  status,
}) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [file, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleOpenModal = (newStatus) => {
    setSelectedStatus(newStatus);
    setShowModal(true);
    dispatch(setOpen(true));
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedStatus();
    setFile(null);
    dispatch(setOpen(false));
  };

  const handleSubmit = async (id) => {
    setIsLoading(true);

    const formData = new FormData();
    formData.append("status", selectedStatus || id);

    if (file) {
      formData.append("report", file);
    }

    try {
      const { response, message } = await Helper.Put({
        url: `${api_Routes.Trust.UpdateStatus}${data?.id}`,
        data: formData,
        hasToken: true,
        isFormData: true,
      });

      if (response) {
        const { response: updatedData } = await Helper.Get({
          url: `${
            api_Routes.Trust.View
          }?per_page=${rowsPerPage}&page=${currentPage + 1}${
            status && status !== "null" ? `&status=${status}` : ""
          }`,
          hasToken: true,
        });

        if (updatedData) {
          setData(updatedData);
        }
        successToaster(message || "Status updated successfully");
        handleClose();
      } else {
        errorToaster(message || "Failed to update status");
      }
    } catch (error) {
      console.error("Error updating status:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <FormControl size="small" className="w-40">
        <Select
          value={data?.status}
          onChange={(e) => handleOpenModal(e.target.value)}
          sx={{
            "& .MuiSelect-select": {
              backgroundColor:
                (data?.status === "in_progress" || data?.status === "active")
                  ? "#28a745"
                  : data?.status === "pending"
                  ? "#f7cb73"
                  : "#114787",
              color: "white",
            },
          }}
        >
          <MenuItem value="in_progress">
            {isLoading ? (
              <CircularProgress size={18} sx={{ color: "white" }} />
            ) : (
              "In Progress"
            )}
          </MenuItem>
          <MenuItem value="active">
            {isLoading ? (
              <CircularProgress size={18} sx={{ color: "white" }} />
            ) : (
              "Active"
            )}
          </MenuItem>
          <MenuItem value="pending">
            {isLoading ? (
              <CircularProgress size={18} sx={{ color: "white" }} />
            ) : (
              "Pending"
            )}
          </MenuItem>
          <MenuItem value="complete">
            {isLoading ? (
              <CircularProgress size={18} sx={{ color: "white" }} />
            ) : (
              "Complete"
            )}
          </MenuItem>
        </Select>
      </FormControl>

      <StatusChangeModal
        show={showModal}
        handleClose={handleClose}
        setFile={setFile}
        handleSubmit={handleSubmit}
        isLoading={isLoading}
        data={data}
        newStatus={selectedStatus}
      />
    </>
  );
};

export default StatusChanger;
